import styled from "styled-components";
import { SkeletonLine } from "../../Componentes/Utils/SkeletonLine";
import { formatCPF } from "../../Funcoes/FormatCPF";

const Hero = styled.section`
    width: 100%;
    box-sizing: border-box;
    background: linear-gradient(135deg, #263B4B 0%, #1c2d3a 100%);
    border-radius: 15px;
    padding: 20px;
    display: flex;
    gap: 20px;
    align-items: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
        align-items: center;
        padding: 18px;
    }
`;

const Pic = styled.div`
    width: 120px;
    height: 160px;
    flex-shrink: 0;
    border-radius: 12px;
    overflow: hidden;
    border: 2px solid rgba(255, 255, 255, 0.25);
    background-color: #1c2d3a;
    display: flex;
    align-items: center;
    justify-content: center;

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

const SemFoto = styled.span`
    font-size: 11px;
    font-weight: 700;
    color: #6b7c89;
`;

const Info = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;

    @media (max-width: 768px) {
        align-items: center;
        width: 100%;
    }
`;

const Nome = styled.h1`
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: #FFFFFF;
    line-height: 1.2;
`;

const Funcao = styled.p`
    margin: 0;
    font-size: 14px;
    color: #b7c4cd;
`;

const MetaRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px 18px;
    margin-top: 4px;

    @media (max-width: 768px) {
        justify-content: center;
    }
`;

const Meta = styled.span`
    font-size: 12px;
    color: #d6dee4;

    & strong {
        color: #FFFFFF;
        font-weight: 700;
    }
`;

const Badge = styled.span`
    align-self: flex-start;
    margin-top: 6px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: ${(p) => (p.$demitido ? "#fecaca" : "#bbf7d0")};
    background-color: ${(p) => (p.$demitido ? "rgba(185, 28, 28, 0.25)" : "rgba(34, 197, 94, 0.2)")};

    &::before {
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: ${(p) => (p.$demitido ? "#ef4444" : "#22c55e")};
    }

    @media (max-width: 768px) {
        align-self: center;
    }
`;

const ProfileHeader = ({ data, loading }) => {

    const status = (data?.STATUS || "").toUpperCase();
    const isDemitido = status.includes("DEMI") || !!data?.DEMISSAO;

    return (
        <Hero>
            <Pic>
                {loading ? (
                    <SkeletonLine style={{ width: "100%", height: "100%", borderRadius: 0, margin: 0 }} />
                ) : data?.IMAGEM ? (
                    <img src={data.IMAGEM} alt="Foto do colaborador" />
                ) : (
                    <SemFoto>SEM FOTO</SemFoto>
                )}
            </Pic>
            <Info>
                {loading ? (
                    <>
                        <SkeletonLine style={{ height: "22px", width: "60%" }} />
                        <SkeletonLine style={{ height: "14px", width: "40%" }} />
                        <SkeletonLine style={{ height: "12px", width: "70%" }} />
                    </>
                ) : (
                    <>
                        <Nome>{data?.NOME || "-"}</Nome>
                        <Funcao>{data?.FUNCAO || "-"}</Funcao>
                        <MetaRow>
                            <Meta><strong>Matrícula:</strong> {data?.MATRICULA || "-"}</Meta>
                            <Meta><strong>CPF:</strong> {data?.CPF ? formatCPF(data.CPF) : "-"}</Meta>
                            <Meta><strong>Centro de custo:</strong> {data?.CENTRO_CUSTO || "-"}</Meta>
                        </MetaRow>
                        <Badge $demitido={isDemitido}>{data?.STATUS || "-"}</Badge>
                    </>
                )}
            </Info>
        </Hero>
    )
}

export default ProfileHeader;
